<template>
  <div class="bg-white p-2 mb-0.5 rounded-md border border-grayNeutralLight flex items-center justify-between gap-1">
    <div class="flex items-center gap-1">
      <svg width="16" height="17">
        <use :xlink:href="`#doc`"></use>
      </svg>
      <div>
        <span class="block font-bold">{{ name }}</span>
        <span class="text-grayNeutralDark pt-0.5 block">{{ period }}</span>
      </div>
    </div>
    <div>
      <svg v-if="loading" width="23" height="23">
        <use :xlink:href="`#loading`"></use>
      </svg>
      <template v-else>
        <ElButton type="primary" size="medium" plain @click="generateReport">Generate</ElButton>
        <ElButton v-if="isReady" size="medium" type="primary" icon="el-icon-download" @click="downloadReport">Download</ElButton>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    period: {
      type: String,
      default: '',
    },
    isReady: {
      type: Boolean,
      default: false,
    },
    flight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async generateReport() {
      this.loading = true
      await this.axios.post(`/api/social-products/social-boost/generate-report/${this.flight.social_boost_campaign_id}/${this.flight.id}`)
      this.loading = false
    },
    async downloadReport() {
      const url = `/api/social-products/social-boost/download-report/${this.flight.social_boost_campaign_id}/${this.flight.id}`
      const link = document.createElement('a')
      link.href = url
      link.click()
    },
  },
}
</script>
